import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NewArrival from '../Home/NewArrival';
import { RiDeleteBin6Line, RiArrowDownSLine } from "react-icons/ri";
import { useProducts } from '../../Context/ProductProvider';
import Loading from '../Loading/Loading';
import { actionTypes } from '../../Context/actionTypes';
import { toast } from 'react-hot-toast';

const Cart = () => {
    const navigate = useNavigate();

    const [selectedProducts, setSelectedProducts] = useState([]);

    const { state: { cart, loading, error }, dispatch } = useProducts();
    console.log(cart)
    let content;

    if (loading) {
        return <Loading></Loading>
    }
    if (error) {
        content = <h1>Something went wrong</h1>
    }
    const total = cart.reduce((total, product) => {
        return (total + (product.offer_price ? product?.offer_price * product?.quantity : product?.price * product?.quantity))
    }, 0)

    const reDriectToCheckOut = () => {
        navigate('/checkout')
        console.log('Selected products:', selectedProducts);
        localStorage.setItem("selectedCart", JSON.stringify(selectedProducts))
    }

    const groupedProducts = cart.reduce((acc, product) => {

        if (!acc[product.shop_id]) {
            acc[product.shop_id || product.category_id] = { shop: product.shop, category: product.category_id, products: [] };
        }
        acc[product.shop_id].products.push(product);

        return acc;
    }, {});


    const handleCheckboxChange = (event, product) => {
        const checked = event.target.checked;
        if (checked) {
            setSelectedProducts((prevState) => [...prevState, product]);
        } else {

            setSelectedProducts((prevState) => prevState.filter((p) => p.id !== product.id));
        }
    };

    return (
        <div className='py-16'>
            {content}

            <div className="container">

                <div className='flex  pt-5 flex-col lg:flex-row gap-4'>
                    {/* first part */}
                    <div className=" w-full mb-10 overflow-x-auto rounded-none">
                        {content}
                        {cart.length ? (
                            <div className='rounded-none'>
                                {Object.values(groupedProducts).map((group) => (
                                    <div className="collapse collapse-open p-0">
                                        <input type="checkbox" />
                                        <div className="collapse-title rounded-none flex justify-between items-center pl-12 bg-slate-200 text-black">
                                            <div>
                                                {group?.shop?.name || group?.category.name}
                                            </div>
                                            <div className='lg:text-2xl sm:text-sm'>
                                                <RiArrowDownSLine></RiArrowDownSLine>
                                            </div>
                                        </div>
                                        <div className="collapse-content p-0 w-full overflow-x-auto" style={{ padding: "0" }}>
                                            <table className="table bg-white  w-full rounded-none">
                                                <tbody className="" >
                                                    {group.products.map((product) => (

                                                        <tr key={product.id} className='border-none rounded-none w-full'>
                                                            <th className='border-0'>
                                                                <label className=''>
                                                                    <input type="checkbox" className="checkbox"
                                                                        checked={selectedProducts.some((p) => p.id === product.id)}
                                                                        onClick={(event) => handleCheckboxChange(event, product)}
                                                                        disabled={selectedProducts.some((p) => p.stock === 0 || (p.stock === 0 && p.quantity > 0))}
                                                                    />
                                                                </label>
                                                            </th>
                                                            <td className='border-none rounded-none static z-0'>
                                                                <div className="flex items-center space-x-3">
                                                                    <div className="avatar">
                                                                        <div className="mask mask-squircle w-12 h-12">
                                                                            <img src={product?.main?.original_url} alt="Avatar Tailwind CSS Component" />
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div className="font-semibold lg:text-lg sm:text-xs  text-ellipsis">{product?.name}</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className='border-none rounded-none'>
                                                                <span className='text-[25px] font-bold'>৳</span>{product?.offer_price ? product?.offer_price : product?.price}
                                                            </td>
                                                            <td className='border-none rounded-none'>
                                                                <div className="flex border border-gray-300 text-gray-600 divide-x divide-gray-300 w-max">
                                                                    <div className="h-8 w-8 lg:text-xl sm:text-sm flex items-center justify-center cursor-pointer select-none"
                                                                        onClick={() => {
                                                                            if ((product.quantity) > 1) {
                                                                                dispatch({ type: actionTypes.DECREASE, payload: product });
                                                                            } else {
                                                                                dispatch({ type: actionTypes.REMOVE_FROM_CART, payload: product });
                                                                            }
                                                                        }}
                                                                    >
                                                                        -
                                                                    </div>
                                                                    <p className="h-8 w-8 text-base flex items-center border-0 outline-none justify-center bg-white p-2">{(product.quantity)}</p>

                                                                    <div className="h-8 w-8 text-xl flex items-center justify-center cursor-pointer select-none"
                                                                        onClick={() => {
                                                                            if (product.quantity < product.stock) {
                                                                                dispatch({ type: actionTypes.INCREASE, payload: product })
                                                                            } else {
                                                                                toast.error(`${product.name} is out of stock`);
                                                                            }
                                                                        }}
                                                                    >
                                                                        +
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className='border-none rounded-none font-'>
                                                                <span className='text-[25px] font-bold'>৳</span> {product?.offer_price ? product?.offer_price * product?.quantity : product?.price * product?.quantity}
                                                            </td>
                                                            <td className='border-none rounded-none'><button onClick={() => dispatch({ type: actionTypes.REMOVE_FROM_CART, payload: product })} className=' outline-none border-none bg-white btn-sm'><RiDeleteBin6Line className='text-2xl text-red-600 hover:text-red-700' /></button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ))}
                                {/* =========== */}
                            </div>

                        ) : (<div className='p-5'>
                            <p className='text-red-500 font-semibold lg:text-2xl sm:text-lg'>Your cart is empty!</p>
                        </div>)}
                    </div>
                    {/* first part end*/}
                    {/* 2nd  part start*/}
                    <div className="card lg:max-w-md sm:w-full lg:max-h-[400px]  bg-base-100 rounded-none mb-20">
                        {cart.length > 0 &&
                            <div className="card-body">
                                <div className='shadow-md p-5'>
                                    <p className='font-[500] text-normal'> Have a coupon? <Link className='link text-blue-500' to='/'>Click Here to enter your code</Link></p>
                                </div>
                                {/* <div className="divider"></div> */}

                                <div className="form-control items-start">
                                </div>
                                <div className="divider"></div>
                                <div className='flex justify-between'>
                                    <h5 className='lg:text-[18px] sm:text-sm font-[500]'>Total: <span className='lg:text-[25px] sm:text-sm font-bold'>৳</span>{total}</h5>
                                    <span className='text-[18px] font-[500]'></span>
                                </div>
                            </div>
                        }
                        <div className="block ">
                            {selectedProducts.length > 0 ?
                                <button onClick={reDriectToCheckOut}  className=" py-2 lg:text-lg sm:text-sm w-full btn-primary bg-gradient-to-l from-primary to-[#52a3eb] hover:from-[#52a3eb] hover:to-primary ease-in-out delay-150 duration-300 transition rounded-none border-none" disabled={selectedProducts.some((p) => p.stock === 0 || (p.stock === 0 && p.quantity > 0))}>Process to Checkout</button> :
                                <button onClick={() => toast.error("Please select one.", {
                                    icon: "⚠️"
                                })} className="block cursor-not-allowed lg:text-lg sm:text-sm  w-full py-2 text-center text-white bg-gradient-to-l from-red-500 to-[#52a3eb] hover:from-[red] hover:to-primary ease-in-out delay-150 duration-300 transition">
                                    Confirm Order
                                </button>
                            }
                        </div>
                    </div>
                    {/* 2nd  part end*/}
                </div>
                <NewArrival className='py-16'></NewArrival>
            </div>

        </div>
    );
};

export default Cart;